export default __webpack_public_path__ + "static/media/Meghna.63db24b5.jpg";